"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DowntimeOverlay = void 0;
var material_1 = require("@mui/material");
var react_1 = __importStar(require("react"));
var utils_1 = require("./utils");
var style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    p: 5,
};
exports.DowntimeOverlay = function (_a) {
    var maintenance = _a.maintenance;
    var _b = react_1.useState(true), open = _b[0], setOpen = _b[1];
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(material_1.Modal, { open: open, onClose: function () { } },
            react_1.default.createElement(material_1.Box, { sx: style },
                react_1.default.createElement(material_1.Typography, { variant: "h6", component: "h2" }, utils_1.interpolate(maintenance.currentState.title, __assign(__assign({}, maintenance.currentState), { notificationsStartDate: utils_1.formatDate(maintenance.currentState.notificationsStartDate), notificationsEndDate: utils_1.formatDate(maintenance.currentState.notificationsEndDate), downtimeStartDate: utils_1.formatDate(maintenance.currentState.downtimeStartDate), downtimeEndDate: utils_1.formatDate(maintenance.currentState.downtimeEndDate) }))),
                react_1.default.createElement(material_1.Typography, { sx: { mt: 2 } }, utils_1.interpolate(maintenance.currentState.downtimeDescription, __assign(__assign({}, maintenance.currentState), { notificationsStartDate: utils_1.formatDate(maintenance.currentState.notificationsStartDate), notificationsEndDate: utils_1.formatDate(maintenance.currentState.notificationsEndDate), downtimeStartDate: utils_1.formatDate(maintenance.currentState.downtimeStartDate), downtimeEndDate: utils_1.formatDate(maintenance.currentState.downtimeEndDate) })))))));
};
